<template>
  <main>
    <div class="container-fluid bg-white py-5">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <notifications />

            <div
              v-if="plan"
              class="form-group row"
            >
              <label class="col-md-12 col-form-label text-md-center">
                <h4>Subscribe to a plan</h4>
              </label>
            </div>

            <div
              v-if="plan"
              class="form-group row"
            >
              <label class="col-md-4 col-form-label text-md-right">
                <h5>Account Type</h5>
              </label>

              <div class="col-md-6 col-form-label ">
                <h5>
                  <span class="label">{{ plan.name }}</span>
                </h5>
              </div>
            </div>

            <div
              v-if="coupon"
              class="form-group row"
            >
              <label class="col-md-4 col-form-label text-md-right">
                <h5>Coupon</h5>
              </label>

              <div class="col-md-6 col-form-label ">
                <h5>
                  <strong>{{ coupon.name }}</strong>:
                  <span
                    v-if="coupon && coupon.percent_off"
                    class="label text-success"
                  >{{ coupon.percent_off }}% OFF</span>
                  <span
                    v-if="coupon && coupon.amount_off"
                    class="label text-success"
                  >{{ coupon.amount_off }} OFF</span>
                  <span
                    v-if="coupon && coupon.duration == 'repeating'"
                    class="label text-success"
                  >for {{ coupon.duration_in_months }} months!</span>
                  <span
                    v-if="coupon && coupon.duration == 'once'"
                    class="label text-success"
                  >your first month!</span>
                  <span
                    v-if="coupon && coupon.duration == 'forever'"
                    class="label text-success"
                  >FOREVER!</span>
                </h5>
              </div>
            </div>

            <div
              v-if="plan"
              class="form-group row"
            >
              <label class="col-md-4 col-form-label text-md-right">
                <h5>Subscription</h5>
              </label>

              <div class="col-md-6 col-form-label ">
                <h5
                  v-if="coupon && coupon.name"
                  class="price-text-disabled"
                >
                  <span class="label">${{ plan.price }}/{{ plan.interval }}</span>
                </h5>
                <h5>
                  <span class="label"><strong>${{ discountedRate }}</strong>/{{ plan.interval }}</span>
                  <span
                    v-if="coupon && coupon.duration == 'repeating'"
                    class="label"
                  >for the first {{ coupon.duration_in_months }} months</span>
                  <span
                    v-if="coupon && coupon.duration == 'once'"
                    class="label"
                  >for your first month, then ${{ plan.price }}/{{ plan.interal }} after</span>
                </h5>
              </div>
            </div>

            <hr>

            <div v-show="plan && ! isCordova">
              <div class="form-group row">
                <label
                  for="card-element"
                  class="col-md-6 offset-md-4 col-form-label"
                >
                  <strong>Payment Information</strong>
                </label>
              </div>
              <form @submit.prevent="applyCoupon">
                <div class="form-group row">
                  <label class="col-md-4 col-form-label text-md-right">Enter Coupon</label>

                  <div class="col-md-6 d-flex">
                    <input
                      v-model="coupon_code"
                      type="text"
                      class="form-control coupon-input"
                      placeholder="Enter Coupon"
                    >
                    <button
                      class="btn btn-success ml-1"
                      type="submit"
                    >
                      Apply
                    </button>
                  </div>
                </div>
              </form>
              <div class="form-group row">
                <label
                  for="card-element"
                  class="col-md-4 col-form-label text-md-right"
                >
                  Enter Credit or Debit Card
                </label>
                <div class="col-md-6">
                  <div
                    ref="card"
                    class="form-control card-input"
                  />
                </div>
              </div>
            </div>

            <div v-if="false">
              <p>Log Messages:</p>
              <pre><p
                v-for="message of log_messages"
                v-text="message"
              /></pre>
            </div>

            <hr v-if="! isCordova" class="mt-4 mb-3">

            <div class="form-group row mb-0">
              <div class="col-md-12 text-center">
                <button
                  class="btn btn-primary btn-lg"
                  @click.prevent="submit"
                  :disabled="subscribeLoading"
                >
                  <span v-if="subscribeLoading">Loading...</span>
                  <span v-else>Subscribe</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>

import Plans from '../services/plans';
import Account from '../services/account';
import Coupons from '../services/coupons';
import axios from 'axios';
import api from "../services/api";

export default {
  data() {
    return {
      plan: null,
      stripe:{},
      elements: {},
      card: {},
      coupon_code: null,
      coupon: null,
      clientSecret: null,
      cordovaHandlerRegistered: false,
      log_messages: [],
      subscribeLoading: false,
    }
  },
  computed: {
    discountedRate() {
      if (this.plan && this.coupon) {

        if (this.coupon.amount_off) {

          let price = this.plan.price_raw - this.coupon.amount_off_raw;

          price = price > 0 ? price : 0;

          return (price/100).toFixed(2);
        }

        if (this.coupon.percent_off) {

          let price = this.plan.price_raw * (this.coupon.percent_off/100);

          return (price/100).toFixed(2);

        }

        return this.plan.price;
      }

      return this.plan.price || null;
    },
    isCordova() {
      return window.IS_CORDOVA;
    },
  },
  mounted() {
    this.loadPlans();
    this.initStripe();
    this.initClientSecret();

    this.log('mounted');

    window.addEventListener('error', (error) => this.log(error));
  },
  methods: {
    log(...args) {
      for (let argument of args) {
        this.log_messages.push(argument);
      }

      console.log(...args);
    },
    async submit () {
      this.subscribeLoading = true;

      try {
        this.$store.dispatch('notifications/clear');

        if (this.isCordova) {
          return await this.submitCordova();
        }

        let params = {};

        params.type = this.plan.type;

        try {
          const { setupIntent, error } = await this.stripe.confirmCardSetup(this.clientSecret, {
            payment_method: {
              card: this.card,
            }
          });

          if (error) {
            throw error;
          } else {
            params.stripe_token = setupIntent.payment_method;
          }
        } catch (err) {
          this.$store.dispatch('notifications/setError', 'Invalid payment information.');
          this.subscribeLoading = false;
          window.scrollTo(0,0);
          return;
        }

        if (this.coupon_code && ((this.coupon && this.coupon_code != this.coupon.id) || !this.coupon)) {
          await this.applyCoupon();

          if (!this.coupon) {
            window.scrollTo(0,0);
            return;
          }
        }

        if (this.coupon) {
          params.coupon = this.coupon.id;
        }

        try {

          let res = await this.$store.dispatch('user/subscribe', params);
          this.$router.push({name: 'subscriptions'});
          this.$store.dispatch('notifications/setSuccess', 'Subscription created.');

        } catch (err) {

          window.scrollTo(0,0);
          this.$store.dispatch('notifications/setError', 'There was a problem subscribing');
          this.$store.dispatch('notifications/setErrorBag', err.response.data.errors || null);
          this.subscribeLoading = false;
        }
      } finally {
        setTimeout(() => {
          this.subscribeLoading = false;
        }, 30 * 1000);
      }
    },

    async submitCordova() {
      const store = CdvPurchase.store || window.CdvPurchase.store || window.store;

      this.log('CdvPurchase.store object', store);

      const storeName = window.IS_CORDOVA_IOS
        ? CdvPurchase.Platform.APPLE_APPSTORE
        : CdvPurchase.Platform.GOOGLE_PLAY;

      const productName = window.IS_CORDOVA_IOS
        ? 'individual_monthly_sub'
        : 'individual_monthly_sub';

      const purchaseCallback = async () => {
        this.log('purchaseCallback called');

        const result = await store.get(productName)
          .getOffer()
          .order();

        this.log('purchaseCallback result: ' + result);
      };

      if (this.cordovaHandlerRegistered) {
        await purchaseCallback();

        return;
      }

      this.cordovaHandlerRegistered = true;

      store.register([{
        type: CdvPurchase.ProductType.PAID_SUBSCRIPTION,
        id: productName,
        platform: storeName,
      }]);

      await store.initialize([storeName]).then(async (errors) => {
        this.log('response in handler of store.initialize: ', errors);
        this.log(JSON.stringify(errors));

        if (errors.length) {
          console.error(errors);

          return;
        }

        this.log('Products: ' + JSON.stringify(store.products));

        const product = store.get(productName);

        this.log({ product })
        this.log(JSON.stringify(product))

        store.when(productName)
          // .expired(prod => store.ready(true))
          .receiptUpdated(async (receipt) => {
            this.log('updated', { receipt });

            if (! receipt?.nativeData?.appStoreReceipt) {
              return;
            }

            const afterHook = await this.handleCordovaSuccess(storeName, null, product, receipt);

            // transaction.finish();

            await afterHook();
          })
          .approved(async (transaction) => {
            this.log('approved', { transaction });

            const afterHook = await this.handleCordovaSuccess(storeName, transaction, product, transaction.parentReceipt);

            transaction.finish();

            await afterHook();
          });

        await purchaseCallback();
      });
    },

    async handleCordovaSuccess(store, transaction, product, receipt) {
      const response = await api.rawPost('/account/validate-purchase', {
        store,
        transaction,
        product,
        receipt,
      })

      if (response.status === 200 && response.data && response.data.expired) {
        return () => this.log('Expired receipt successfully processed');
      }

      if (response.status >= 400) {
        await this.$router.push({ name: 'subscriptions' });

        await this.$store.dispatch('notifications/setError', 'Failed to validate subscription');

        console.error(response);

        throw new Error('Failed to created subscription');
      }

      return async () => {
        await this.$router.push({ name: 'subscriptions' });

        await this.$store.dispatch('user/getUser');

        await this.$store.dispatch('notifications/setSuccess', 'Subscription created.');
      };
    },

    loadPlans() {

      Plans.get().then((res) => {

        let plans = res.data;
        let type = this.$route.params.type;

        switch (type) {
        case 'food-service-limited':
          this.plan = plans.food_service_limited;
          break;
        case 'food-service-full':
          this.plan = plans.food_service_full;
          break;
        case 'individual':
        default:
          this.plan = plans.individual;
          break;
        }

      }).catch((err) => {
        this.$store.dispatch('notifications/setError', 'Unable to load plans.  Please reload and try again.');
      });
    },

    async applyCoupon() {

      this.$store.dispatch('notifications/clear');

      return Coupons.get(this.coupon_code).then(res =>{
        this.coupon = res.data;
      }).catch(err => {
        this.coupon = null;
        this.$store.dispatch('notifications/setError', 'Invalid coupon code provided.');
      });
    },

    initStripe() {
      let style = {
        base: {
          // Add your base input styles here. For example:
          fontSize: '1.1em',
          fontWeight: '100',
        }
      };

      this.stripe = Stripe(window.STRIPE_KEY);
      this.elements = this.stripe.elements();

      this.card = this.elements.create('card', {style: style});
      this.card.mount(this.$refs.card);
    },

    initClientSecret() {
      api.post('/account/begin-card-setup')
        .then(response => {
          this.clientSecret = response.client_secret;
        }).catch(error => {
          this.$store.dispatch('notifications/setError', JSON.stringify(error));
          window.scrollTo(0,0);
        });
    }
  }
}
</script>

<style lang="scss" scoped>
    .error {
        color: red;
    }
    .card-input {
        padding-top: .6em;
    }
    .coupon-input {
        font-size: 1.1em;
    }
    .price-text {
        font-size: 2.8em;

        &-disabled {
            text-decoration: line-through;
            color: red;
            font-style: italic;
        }
    }
</style>
